module.exports = __webpack_public_path__ + "img/fornitori.a3404096.svg";